import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import api from '../api/client.js';
import PasswordInput from '../components/PasswordInput.jsx';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get('token') || '';
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <Frame>
        <div className="card p-6 text-sm space-y-3">
          <div className="font-medium text-crimson">Invalid reset link.</div>
          <p className="text-muted">The link is missing its token. Request a new one from the sign-in page.</p>
          <Link to="/forgot-password" className="text-navy hover:underline">Request new link</Link>
        </div>
      </Frame>
    );
  }

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    if (next !== confirm) { setErr('Passwords do not match'); return; }
    if (next.length < 12) { setErr('Password must be at least 12 characters'); return; }
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: next });
      setDone(true);
      setTimeout(() => nav('/login', { replace: true }), 2000);
    } catch (e) {
      setErr(e?.response?.data?.error || 'Reset failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Frame>
      {!done && (
        <form onSubmit={onSubmit} className="card p-6 space-y-4">
          <p className="text-sm text-muted">Set a new password (12+ characters).</p>
          <div>
            <label className="label">New password</label>
            <PasswordInput value={next} onChange={e => setNext(e.target.value)}
                           autoComplete="new-password" required minLength={12} autoFocus />
          </div>
          <div>
            <label className="label">Confirm new password</label>
            <PasswordInput value={confirm} onChange={e => setConfirm(e.target.value)}
                           autoComplete="new-password" required minLength={12} />
          </div>
          {err && <div className="text-crimson text-sm">{err}</div>}
          <button type="submit" disabled={busy} className="btn-primary w-full">
            {busy ? 'Updating…' : 'Set new password'}
          </button>
        </form>
      )}
      {done && (
        <div className="card p-6 text-sm space-y-2">
          <div className="font-medium text-navy">Password updated.</div>
          <p className="text-muted">Redirecting to sign in…</p>
        </div>
      )}
    </Frame>
  );
}

function Frame({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="bg-navy h-2" />
      <div className="bg-crimson h-1" />
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-sm">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold mt-2">Reset Password</h1>
            <div className="rule-crimson mx-auto" />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
